export default "__VITE_ASSET__BmkJrQoI__"